import { render, staticRenderFns } from "./AppSN.vue?vue&type=template&id=34aaec96&scoped=true&"
import script from "./AppSN.vue?vue&type=script&lang=js&"
export * from "./AppSN.vue?vue&type=script&lang=js&"
import style0 from "./AppSN.vue?vue&type=style&index=0&id=34aaec96&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/main.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aaec96",
  null
  
)

export default component.exports